export { default } from './FacilitiesAndRoom';
